import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const CardContainerRetro = ({
  children,
  bg,
  w = "auto",
  rd = 4,
  p = 0,
  weight = "bold",
  borderType = "full",
  style,
  onClick,
}) => {
  const theme = useTheme();
  
  const getBorderWidth = (borderType, weight) => {
    if (borderType === "bottom") {
      return weight === "bold" ? "0 0 4px 0" : "0 0 2px 0";
    }
    return weight === "bold" ? "1px 4px 4px 1px" : "0.5px 3px 3px 0.5px";
  };

  return (
    <Box
      sx={{
        borderStyle: "solid",
        borderColor: theme.palette.primary.main,
        borderWidth: getBorderWidth(borderType, weight),
        borderRadius: `${rd}px`,
        overflow: "hidden",
        padding: theme.spacing(p),
        backgroundColor: bg || theme.palette.background.paper,
        width: w,
        display: "flex",
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};
